import { createAction } from 'redux-starter-kit';
import api from 'api/bundles';
import apiUmbrella from 'api/umbrella-backend';
import * as Const from 'util/constants';
import { selectBundleType } from 'actions/user';

export const fetchBundles = createAction('bundles/FETCH_START');
export const fetchBundlesSuccess = createAction('bundles/FETCH_SUCCESS');
export const fetchBundlesFailure = createAction('bundles/FETCH_FAILURE');
export const setRelatedSearches = createAction('bundles/SET_RELATED_SEARCHES');

export const cacheSettings = createAction('bundles/CACHE_SETTINGS');
export const resetSettings = createAction('bundles/RESET_SETTINGS');
export const clearResults = createAction('bundles/CLEAR_RESULTS');

export const searchFor = createAction('bundles/SEARCH');
export const setSearchFor = createAction('bundles/SET_SEARCH');
export const filterByLevel = createAction('bundles/FILTER_BY_LEVEL');
export const filterByCateg = createAction('bundles/FILTER_BY_CATEG');
export const changeOrder = createAction('bundles/CHANGE_ORDER');

export const preloadBundle = createAction('bundle/PRELOAD');
export const fetchBundle = createAction('bundle/FETCH_START');
export const fetchBundleSuccess = createAction('bundle/FETCH_SUCCESS');
export const fetchBundleFailure = createAction('bundle/FETCH_FAILURE');
export const clearCurrentBundle = createAction('bundle/CLEAR_CURRENT_BUNDLE');

export const fetchAudios = createAction('audios/FETCH_START');
export const fetchAudiosSuccess = createAction('audios/FETCH_SUCCESS');
export const fetchAudiosFailure = createAction('audios/FETCH_FAILURE');
export const resetAudiosSettings = createAction('audios/RESET_SETTINGS');

export const fetchUltimateBundle = createAction('bundle/FETCH_ULTIMATE_START');
export const fetchUltimateBundleSuccess = createAction('bundle/FETCH_ULTIMATE_SUCCESS');
export const fetchUltimateBundleFailure = createAction('bundle/FETCH_ULTIMATE_FAILURE');

export const asyncFetchBundles = more => async (dispatch, getState) => {
  // determine if there is any change in state that would trigger a fetch
  const { list, level, searchFor, categId, prevState } = getState().bundles;
  const { bundleType } = getState().user;
  const settingsDifferent = JSON.stringify({ bundleType, level, searchFor, categId }) !== prevState;
  if (settingsDifferent) {
    dispatch(clearResults());
  }
  if (more || settingsDifferent || !list.length) {
    dispatch(fetchBundles());
    api
      .fetchBundles(paramsFromState(getState()))
      .then(results => {
        dispatch(fetchBundlesSuccess(results.bundles || results));
        if (results.related_searches) {
          dispatch(setRelatedSearches(results.related_searches));
        } else {
          dispatch(setRelatedSearches([]));
        }
        dispatch(cacheSettings(bundleType));
      })
      .catch(error => dispatch(fetchBundlesFailure({ error: error.message })));
  }
};

export const asyncSearchForBundles = (term, type = null) => async dispatch => {
  if (type) dispatch(selectBundleType(type));
  dispatch(searchFor(term));
  dispatch(asyncFetchBundles());
};

export const changeSearchForBundles = term => async dispatch => {
  dispatch(setSearchFor(term));
};

export const asyncFilterBundlesByLevel = level => async dispatch => {
  dispatch(filterByLevel(level));
  dispatch(asyncFetchBundles());
};

export const asyncFilterBundlesByCateg = categ => async (dispatch, getState) => {
  // dispatch(resetSettings());
  dispatch(filterByCateg(categ));
  dispatch(asyncFetchBundles());
};

export const asyncFetchBundle = (bundleId, productType) => async (dispatch, getState) => {
  dispatch(fetchBundle());
  const requests = [api.fetchBundle(bundleId)];

  if (productType) {
    requests.push(apiUmbrella.fetchMappedProduct(productType, bundleId));
  }

  Promise.all(requests)
    .then(([bundle, data]) => {
      if (data) {
        bundle.clickFunnelsProductId = data.clickFunnelsProductId;
      }

      dispatch(fetchBundleSuccess(bundle));
    })
    .catch(error => dispatch(fetchBundleFailure({ error: error.message })));
};

export const asyncFetchAudios = (currentPage, keyword) => async (dispatch, getState) => {
  dispatch(fetchAudios(keyword));
  api
    .fetchAudios(paramsForAudios(getState(), currentPage, keyword))
    .then(audios => {
      dispatch(fetchAudiosSuccess(audios));
    })
    .catch(error => dispatch(fetchAudiosFailure({ error: error.message })));
};

const paramsFromState = state => {
  const { batchSize, level, searchFor, currentPage, categId, orderBy } = state.bundles;
  const { bundleType } = state.user;
  return {
    type: !bundleType || bundleType === Const.TYPE_IMAGE_BUNDLES ? 'image' : 'audio',
    level,
    search_for: searchFor,
    per_page: batchSize,
    categ_id: categId,
    page: currentPage + 1,
    order_by: orderBy
  };
};

const paramsForAudios = (state, currentPage, keyword) => {
  const { currentBundle, audiosBatchSize, searchForAudios } = state.bundles;
  return {
    bundleId: currentBundle.id,
    search_for: keyword !== undefined ? keyword : searchForAudios,
    per_page: audiosBatchSize,
    page: currentPage
  };
};

export const asyncFetchUltimate = () => async dispatch => {
  dispatch(fetchUltimateBundle());

  apiUmbrella
    .fetchMappedProduct('image', 'ultimate')
    .then(data => {
      dispatch(fetchUltimateBundleSuccess(data));
    })
    .catch(error => dispatch(fetchUltimateBundleFailure({ error: error.message })));
};
